import LazyImage from "./LazyImage";
import { CMSImageProps } from "./image.type";

const CMSImage = ({
  src,
  srcSet,
  rootUrl,
  identifier,
  imageSizes,
  css,
  ...props
}: CMSImageProps) => {
  const defaultSrcSet = imageSizes
    ? `${rootUrl}/.imaging/${imageSizes.small}/dam/${identifier} 640w, ${rootUrl}/.imaging/${imageSizes.medium}/dam/${identifier} 1024w, ${rootUrl}/.imaging/${imageSizes.large}/dam/${identifier} 1200w, ${rootUrl}/.imaging/${imageSizes["x-large"]}/dam/${identifier} 1920w`
    : `${rootUrl}/.imaging/small/dam/${identifier} 640w, ${rootUrl}/.imaging/medium/dam/${identifier} 1024w, ${rootUrl}/.imaging/large/dam/${identifier} 1200w, ${rootUrl}/.imaging/x-large/dam/${identifier} 1920w`;
  if (rootUrl) {
    return (
      <LazyImage
        srcSet={srcSet || defaultSrcSet}
        src={src}
        {...props}
        css={css}
      ></LazyImage>
    );
  }
  return <LazyImage src={src} srcSet={srcSet} {...props}></LazyImage>;
};

export default CMSImage;
